module.exports = __webpack_public_path__ + "static/media/Paula_Millen_Facilidade.095af4f2.jpg";